<div aria-hidden="true" class="d-none">
  <ul>
    <li *ngFor="let navItem of mainNavigation; let x = index">
      <a
        [attr.href]="navItem.targetUrl"
        [attr.target]="navItem?.openinnewTab === 'true' ? '_blank' : '_self'"
        data-src="travel-info_360_firstClass.png"
      >
        {{ navItem.brandLabel }}
      </a>
    </li>
  </ul>
  <ul>
    <li *ngFor="let childPage of contentChild; let y = index">
      <a
        [attr.href]="childPage.pageUrl"
        [attr.target]="childPage?.openinnewTab === 'true' ? '_blank' : '_self'"
        data-src="travel-info_360_firstClass.png"
      >
        {{ childPage.pageName }}
      </a>
    </li>
  </ul>
</div>
